export default "__VITE_ASSET__DZzAvBmS__"